import { inject, InjectionToken } from '@angular/core';
import { AlertService } from '../services';
import { from, Observable } from 'rxjs';
import { AlertOptions } from '@ionic/angular';

export const ALERT_TOKEN: InjectionToken<AlertProvider> = new InjectionToken<AlertProvider>('ALERT_TOKEN', {
  factory: (): AlertProvider => {
    const alertService: AlertService = inject(AlertService);

    return {
      presentAlert$(opts: AlertOptions): Observable<void> {
        return from(alertService.presentAlert(opts));
      }
    };
  }
});

export interface AlertProvider {
  presentAlert$(opts: AlertOptions): Observable<void>;
}
